<div class="col-xl">
    <div class="card mb-4">
        <div class="card-body">
            <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Listado de colaboradores</h5>
                <div class="employee-viewing-period-banner" *ngIf="viewingPeriod">
                    <i class="ti ti-info-circle"></i>
                    Mostrando periodo {{formatDate(viewingPeriod.period_date)}}
                    <button type="button" class="employee-viewing-period-back-btn" (click)="volverAlPeriodoActual()">
                        <i class="ti ti-corner-up-left"></i>&nbsp;Volver al periodo actual
                    </button>
                </div>
                <ng-container *ngIf="!viewingPeriod">
                    <button type="button" class="btn employee-close-payroll-btn" *ngIf="hasOpenPeriod && canCloseNomina()"
                        (click)="openCierreNominaModal()">
                        <img src="assets/img/icons/imss-lock.svg" alt="">&nbsp;Cierre total de nómina
                    </button>
                    <button type="button" class="btn employee-close-payroll-btn is-disabled-look" *ngIf="!hasOpenPeriod" disabled>
                        <img src="assets/img/icons/imss-lock.svg" alt="">&nbsp;Nómina total cerrada
                    </button>
                </ng-container>
            </div>

            <div class="d-flex flex-wrap justify-content-between align-items-end mb-3 employee-filters-row">
                <div class="d-flex flex-wrap gap-3">
                    <div class="employee-filter-group">
                        <label class="form-label fw-bold mb-1">Nombre y apellido</label>
                        <input type="text" class="form-control employee-filter-control" placeholder="Buscar"
                            [(ngModel)]="filterSearch" (ngModelChange)="onFiltersChanged()">
                    </div>
                    <div class="employee-filter-group">
                        <label class="form-label fw-bold mb-1">Disponibilidad</label>
                        <select class="form-select employee-filter-control" [(ngModel)]="filterAvailability"
                            (ngModelChange)="onFiltersChanged()">
                            <option *ngFor="let opt of availabilityOptions" [value]="opt.value">{{opt.label}}</option>
                        </select>
                    </div>
                    <div class="employee-filter-group">
                        <label class="form-label fw-bold mb-1">Fecha</label>
                        <input type="date" class="form-control employee-filter-control" [(ngModel)]="filterDate"
                            (ngModelChange)="onFiltersChanged()">
                    </div>
                    <div class="employee-filter-group">
                        <label class="form-label fw-bold mb-1">Estatus</label>
                        <select class="form-select employee-filter-control" [(ngModel)]="filterPayrollStatus"
                            (ngModelChange)="onFiltersChanged()">
                            <option *ngFor="let opt of statusOptions" [value]="opt.value">{{opt.label}}</option>
                        </select>
                    </div>
                </div>
                <div *ngIf="!viewingPeriod && canDo('Crear')">
                    <button type="button" class="btn btn-primary employee-add-btn" routerLink="/employee/new">
                        <i class="ti ti-plus"></i>&nbsp;Registrar colaborador
                    </button>
                </div>
            </div>

            <div class="employee-grid ag-theme-alpine" style="height: 55vh; width: 100%;">
                <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true" [context]="gridContext"
                    [loadingCellRenderer]="loadingCellRenderer" [loadingCellRendererParams]="loadingCellRendererParams"
                    [overlayNoRowsTemplate]="noRowsTemplate" (gridReady)="onGridReady($event)"
                    (cellClicked)="onCellClicked($event)">
                </ag-grid-angular>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="text-muted small">Total: {{totalRows}}</div>
            <div class="d-flex align-items-center">
                <label class="me-2 mb-0">Filas por página:</label>
                <select class="form-select form-select-sm me-2" style="width: auto;"
                    (change)="onPageSizeChanged($any($event.target).value)">
                    <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
                </select>
                <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()"
                    [disabled]="currentPage <= 1">
                    <i class="ti ti-chevron-left"></i>
                </button>
                <span class="me-2">Página {{currentPage}} de {{lastPage}}</span>
                <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()"
                    [disabled]="currentPage >= lastPage">
                    <i class="ti ti-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Dar de baja a un colaborador -->
<app-termination-modal #terminationModal modalId="terminationModal" (terminated)="onEmployeeTerminated($event)"></app-termination-modal>

<!-- Modal: Cierre total de nómina -->
<app-cierre-nomina-modal #cierreNominaModal modalId="cierreNominaModal" (closed)="onNominaCerrada($event)"></app-cierre-nomina-modal>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
